import { render, staticRenderFns } from "./yuanJianPay.vue?vue&type=template&id=56ab489a&"
import script from "./yuanJianPay.vue?vue&type=script&lang=js&"
export * from "./yuanJianPay.vue?vue&type=script&lang=js&"
import style0 from "./yuanJianPay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports